
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import BackTop from '@/common/backtop.vue';
import { Component, Vue } from 'vue-property-decorator';
import { readCookie, removeCookie } from '@/tools/tools';
import {
  productTypeListPC,
  productTypeList,
  getIndexNav,
  getIndexNavDetails,
  receiveCoupon
} from '@/services/http';
import * as _ from 'lodash';

@Component({
  components: {
    Header,
    Footer,
    BackTop
  }
})
export default class extends Vue {
  isLoading: boolean = false

  value: string = ''

  isLogin: boolean = false

  isShow: boolean = readCookie('anchor')

  isClassifyShow: boolean = false

  productTypeId: number = 0

  imageHeight: number = 0

  // 导航第一个分类id
  firstProductId: string = ''

  // 分类列表
  productTypeList: [] = []

  // 分类列表子分类
  productTypeChildren: any[] = []

  classifyIndex: number = 0

  currentIndex: number = -1

  isMenuShow: boolean = false

  navList: any[] = []

  dataInfo: any = {}

  created() {
    this.getIndexNavDetails();
    this.getIndexNav();
    this.getProductTypeList();
  }

  handleCommand(command: string) {
    if (command === 'login') {
      const anchor = readCookie('anchor');
      if (anchor) {
        if (this.compareVersion(anchor.version, '3.10.600') >= 0) {
          (this as any).webTransport.getUserLoginData(JSON.stringify({}));
        } else if (this.compareVersion(anchor.version, '3.6.5') >= 0) {
          (window as any).QCefClient.invokeMethod('getUserLoginData', JSON.stringify({}));
        } else {
          (window as any).JsIntrS.getUserLoginData({});
        }
      }
      removeCookie('accessToken');
      this.$router.push('/login');
    } else {
      this.$router.push('/user');
    }
  }

  // 比较版本
  compareVersion(v1: any, v2: any) {
    v1 = v1.split('.');
    v2 = v2.split('.');
    const len = Math.max(v1.length, v2.length);

    // 调整两个版本号位数相同
    while (v1.length < len) {
      v1.push('0');
    }
    while (v2.length < len) {
      v2.push('0');
    }

    // 循环判断每位数的大小
    for (let i = 0; i < len; i++) {
      const num1 = parseInt(v1[i]);
      const num2 = parseInt(v2[i]);

      if (num1 > num2) {
        return 1;
      } if (num1 < num2) {
        return -1;
      }
    }

    return 0;
  }

  goback() {
    this.$router.back();
  }

  refresh() {
    window.location.reload();
  }

  goOrderList() {
    window.location.href = '/order-list';
  }

  goMessage() {
    this.$router.push('/notifys');
  }

  private search() {
    if (this.value) {
      window.location.href = `/classify?keyword=${this.value}`;
    } else {
      this.$message.error('请输入商品名称或品牌');
    }
  }

  dropdownClassify() {
    this.dropdownClick(Number(this.firstProductId), 0);
    this.currentIndex = 0;
    this.isClassifyShow = true;
    this.isMenuShow = true;
  }

  async selectHref(item: any) {
    if (item.urlType === 2) {
      const res: any = await receiveCoupon({
        couponId: item.url,
        productId: ''
      });
      if (res.data.code === 100) {
        this.$message.success('领取成功');
      } else {
        this.$message.success(res.data.message);
      }
    } else {
      window.location.href = item.url;
    }
  }

  private async getProductTypeList() {
    const res: any = await productTypeListPC({
      companyId: 1
    });
    this.productTypeList = res.data.data;
    this.firstProductId = res.data.data[0].id;
  }

  private async dropdownClick(productTypeId: number, index: number) {
    this.currentIndex = index;
    this.productTypeId = productTypeId;
    const res: any = await productTypeList({
      productTypeId,
      companyId: 1
    });
    if (res.data.code === 100) {
      this.productTypeChildren = res.data.data.children;
      this.classifyIndex = this.productTypeChildren.length;
      this.isMenuShow = true;
    }
  }

  private goDetails(productTypeId: string) {
    window.location.href = `/classify?productTypeId=${productTypeId}`;
  }

  // 浏览更多
  watchMore() {
    this.$router.push(`/classify?parentTypeId=${this.productTypeId}`);
  }

  mouseLeave() {
    if (this.$route.name !== 'home') {
      this.isClassifyShow = false;
    }
    this.isMenuShow = false;
    this.currentIndex = -1;
  }

  async getIndexNavDetails() {
    this.isLoading = true;
    if (!this.$route.query.id) {
      this.$router.push('/');
      this.$message.error('数据有误，请重新进入');
    }
    const res: any = await getIndexNavDetails({ id: this.$route.query.id });
    if (res.data.code === 100) {
      this.dataInfo = res.data.data;
      this.isLoading = false;
      this.imageHeight = Number(this.dataInfo.topicImage.height);
      //       top: (Number(item.id.split(',')[1]) / dataInfo.topicImage.height) * 100 + '%',
      // left: (Number(item.id.split(',')[0]) / 1198) * 100 + '%',
      // width: (Number(item.id.split(',')[2]) / 1198) * 100 + '%',
      // height: (Number(item.id.split(',')[3]) / dataInfo.topicImage.height) * 100 + '%',
      this.dataInfo.list.forEach((value: any) => {
        this.$set(
          value,
          'top',
          _.round(_.multiply(_.divide(Number(value.id.split(',')[1]), this.imageHeight), 100), 2)
        );
        this.$set(
          value,
          'left',
          _.round(_.multiply(_.divide(Number(value.id.split(',')[0]), 1198), 100), 2)
        );
        this.$set(
          value,
          'width',
          _.round(_.multiply(_.divide(Number(value.id.split(',')[2]), 1198), 100), 2)
        );
        this.$set(
          value,
          'height',
          _.round(_.multiply(_.divide(Number(value.id.split(',')[3]), this.imageHeight), 100), 2)
        );
      });
      // this.setList();
    }
  }

  openWin(item: any) {
    if (item.navType === 1) {
      this.$router.push(`/classify?productTypeId=${item.navTypeValue}`);
    } else if (item.navType === 2) {
      this.$router.push(`/details?id=${item.navTypeValue}`);
    } else if (item.navType === 3) {
      this.$router.push(`/special?id=${item.id}`);
    } else {
      this.$router.push('/consumables');
    }
  }

  setList() {
    if (this.dataInfo.type === 2) {
      this.dataInfo.list = this.dataInfo.list.map((item: any) => {
        const data = item;
        const arr = data.id.split(',').map(Number);
        // eslint-disable-next-line no-mixed-operators
        // arr.splice(0, 1, (1200 / width) * arr[2] + arr[0] - 30);
        // arr.splice(2, 1, (1200 / width) * arr[2] + arr[2]);
        data.id = arr.join(',');
        return data;
      });
    } else {
      this.$router.push('/');
      this.$message.error('数据有误，请重新进入');
    }
  }

  // 获取专题页
  async getIndexNav() {
    const res: any = await getIndexNav({ type: 2, companyId: 1 });
    if (res.data.code === 100) {
      this.navList = res.data.data;
    }
  }
}
